export enum TodoStatus {
  New = "New",
  Accepted = "Accepted",
  InProgress = "InProgress",
  Done = "Done"
}
